module.exports = __webpack_public_path__ + "img/teacher_notifications_certificates_button.10fb3c15.jpg";